import React from "react";
import { NavLink, Link } from "react-router-dom";

export default class Buttom extends React.Component {
  constructor(props) {
    super(props);
  }
  linkList = [
    {
      id: "nav-D",
      class: "w_18p",
      to: "/home",
      imgSrc:
        "http://nb.isbelle.com.cn/templets/2018/wap/images/index/home.png",
      imgClass: "w_40p a",
      imgSrc2:
        "http://nb.isbelle.com.cn/templets/2018/wap/images/index/home1.png",
      imgClass2: "w_50p",
    },
    {
      class: "hd w_18p",
      to: "/home",
      imgSrc: "http://nb.isbelle.com.cn/templets/2018/wap/images/index/yh.png",
      imgClass: "w_40p",
      imgSrc2:
        "http://nb.isbelle.com.cn/templets/2018/wap/images/index/yh1.png",
      imgClass2: "w_50p",
    },
    {
      class: "ce w_18p",
      to: "/ll",
    },
    {
      id: "zx",
      class: "zx w_18p",
      to: "/linkMap",
      imgSrc: "http://nb.isbelle.com.cn/templets/2018/wap/images/index/dz.png",
      imgClass: "w_40p",
      imgSrc2:
        "http://nb.isbelle.com.cn/templets/2018/wap/images/index/dz1.png",
      imgClass2: "w_100p",
    },
    {
      class: "w_18p",
      to: "/home",
      imgSrc: "http://nb.isbelle.com.cn/templets/2018/wap/images/index/dh.png",
      imgClass: "w_40p",
      imgSrc2:
        "http://nb.isbelle.com.cn/templets/2018/wap/images/index/dh1.png",
      imgClass2: "w_50p",
    },
  ];
  swt = () => {
    let myhref = window.location.href;
    let swtlj =
      "http://plt.zoosnet.net/LR/Chatpre.aspx?id=PLT65467523&lng=cn&r=" +
      encodeURIComponent(document.referrer) +
      "&p=" +
      encodeURIComponent(myhref);
    window.open(swtlj, "_blank");
  };
  linkClick = (e) => {
    console.log("e", e);
    if (
      e.target.src ===
      "http://nb.isbelle.com.cn/templets/2018/wap/images/index/dh.png"
    ) {
      window.location.href = `tel:073182204788`;
    } else if (
      e.target.src ===
      "http://nb.isbelle.com.cn/templets/2018/wap/images/index/yh.png"
    ) {
      this.swt();
    }
  };
  render() {
    let mapTem = (index, v) => {
      if (index === 2) {
        return (
          <div key={index} className="ce w_28p" onClick={this.swt}>
            <div className="fg0">
              <p>45</p>
            </div>
          </div>
        );
      } else {
        return (
          <Link
            key={index}
            id={v.id}
            className={v.class}
            to={v.to}
            onClick={this.linkClick}
          >
            <img className={v.imgClass} src={v.imgSrc} alt="" />
            <img className={v.imgClass2} src={v.imgSrc2} alt="" />
          </Link>
        );
      }
    };
    return (
      <div>
        <div className="zdyimg">
          <a href="tel:0731-82204788">
            <img src="http://nb.isbelle.com.cn/templets/2018/wap/images/index/tel.jpg" />
          </a>
        </div>
        {/* <div className="zdyimg">
          <a>
            <img src="http://nb.isbelle.com.cn/templets/2018/wap/images/ewm1.jpg?1" />
          </a>
        </div>
        <div className="zdyimg">
          <a href="https://beian.miit.gov.cn/#/Integrated/recordQuery">
            <img src="http://nb.isbelle.com.cn/templets/2018/wap/images/ewm2.jpg?1" />
          </a>
        </div> */}
        <div className="zdyimg" style={{ marginBottom: "60px" }}>
          <a>
            {/* <img src="http://nb.isbelle.com.cn/templets/2018/wap/images/ewm.jpg" /> */}
            <img src={require("../assets/images/ewm.jpg")} />
          </a>
        </div>

        <div id="fixed-footer" className="fixed-footer">
          <div className="nav1">
            {/* {mapTem} */}
            {this.linkList.map((v, index) => mapTem(index, v))}
          </div>
        </div>
      </div>
    );
  }
}
